import script from "./ProjectInvoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectInvoices.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectInvoices.vue?vue&type=style&index=0&id=674fdd9f&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674fdd9f"]])

export default __exports__